<template>
  <sfs-form-modal
    :id="modalId"
    title="Link to Work Order"
    @on-hide="resetForm"
  >
    <b-form @submit.stop.prevent="handleSubmit">
      <b-row>
        <b-col>
          <b-alert
            :show="hasBaseServerErrors()"
            variant="danger"
            dismissible
          >
            <p
              class="mb-0"
              v-for="(error, index) in baseServerErrors"
              :key="index"
            >
              {{ error }}
            </p>
          </b-alert>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Work Order"
            label-for="quote-link-work_order_id"
          >
            <work-order-select
              id="quote-link-work_order_id"
              :select-class="{ 'is-invalid': $v.form.work_order_id.$dirty && $v.form.work_order_id.$error }"
              select-label="number"
              placeholder="Enter a Number"
              :filter-params="{ client_id: value.client_id, location_id: value.location_id }"
              :value="form.work_order"
              @input="onWorkOrderChange"
            />
            <small class="form-text text-secondary">Find a Work Order to link to</small>
            <b-form-invalid-feedback
              v-if="$v.form.work_order_id.$dirty"
              id="quote-link-work_order_id-feedback"
            >
              <span v-if="!$v.form.work_order_id.required">Please enter a Work Order to link.</span>
              <span v-if="!$v.form.work_order_id.serverFailed">{{ serverErrors.work_order_id }}</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          offset-lg="6"
          lg="3"
          order="2"
          order-lg="1"
        >
          <b-button
            variant="link-dark"
            block
            id="work-order-link-close-button"
            @click="closeModal"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col
          lg="3"
          order="1"
          order-lg="2"
        >
          <b-button
            id="work-order-link-submit-button"
            block
            type="submit"
            variant="primary"
            :disabled="processing"
          >
            Link
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </sfs-form-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import formMixin from '@/mixins/formMixin';
import formModalMixin from '@/mixins/formModalMixin';
import WorkOrderSelect from '@/components/admin/workOrders/Select.vue';

export default {
  name: 'WorkOrdersLinkModal',
  components: {
    WorkOrderSelect,
  },
  mixins: [formMixin, formModalMixin],
  props: {
    value: Object,
  },
  data() {
    return {
      form: {
        work_order: this.value.work_order,
        work_order_id: this.value.work_order_id,
      },
      modalId: 'quote-link-modal',
    };
  },
  validations: {
    form: {
      work_order_id: {
        required,
        serverFailed() {
          return !this.hasServerErrors('work_order_id');
        },
      },
    },
  },
  methods: {
    onWorkOrderChange(work_order) {
      this.form.work_order_id = work_order ? work_order.id : null;
      this.form.work_order = work_order;
    },
    handleSubmit() {
      if (this.hasFormErrors()) {
        return;
      }
      this.$quotesAPI
        .update(this.value.id, this.form)
        .then((quote) => {
          this.resetServerErrors();
          this.$v.$reset();
          this.$emit('input', quote);
          this.closeModal();
        })
        .catch((error) => {
          this.processServerErrors(error.response.data.errors);
        });
    },
  },
};
</script>
